import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";
import { Form, Row } from "react-bootstrap";

import CreatableSelect from "react-select/creatable";

import classes from "../../maintainers.module.scss";

const tableStyles = {
	fontSize: "11px",
};

const rowStyles = {
	lineHeight: "1",
};

const cellStyles = {
	padding: "4px",
};

const selectStyles = {
	control: (base) => ({
		...base,
		minHeight: "25px",
		height: "auto",
	}),
	valueContainer: (base) => ({
		...base,
		height: "auto",
		padding: "2px",
	}),
	input: (base) => ({
		...base,
		margin: 0,
		padding: 0,
	}),
	multiValue: (base) => ({
		...base,
		margin: "1px",
	}),
};

const TabUses = ({ data, setData }) => {
	const { crops, pests } = useSelector((state) => state.maintainers_products);

	const [localCrops, setLocalCrops] = useState([]);
	const [localPests, setLocalPests] = useState([]);

	useEffect(() => {
		setLocalCrops(crops);
		setLocalPests(pests);

		// eslint-disable-next-line
	}, []);

	return (
		<Row className={`${classes.row_form} ${classes.list}`} style={{ marginTop: "5px" }}>
			<table className={classes.table}>
				<thead className={classes.thead}>
					<tr>
						<td>Cultivo</td>
						<td>Plaga</td>
						<td>Carencia</td>
						<td>Reingreso (hrs)</td>
					</tr>
				</thead>
				<tbody style={tableStyles}>
					{data.uses && data.uses.length > 0 ? (
						[...data.uses]
							.sort((a, b) => {
								const cropA = localCrops.find((c) => c.value === a.crop_id)?.label || "";
								const cropB = localCrops.find((c) => c.value === b.crop_id)?.label || "";
								return cropA.localeCompare(cropB);
							})
							.reduce((acc, use) => {
								const existingIndex = acc.findIndex((item) => item.crop_id === use.crop_id);

								if (existingIndex === -1) {
									acc.push({
										crop_id: use.crop_id,
										grace_period: use.grace_period,
										re_entry: use.re_entry,
										common_pests: use.type === "comun" ? use.pests : "",
										scientific_pests: use.type === "cientifico" ? use.pests : "",
									});
								} else {
									if (use.type === "comun") {
										acc[existingIndex].common_pests = use.pests;
									} else {
										acc[existingIndex].scientific_pests = use.pests;
									}
								}
								return acc;
							}, [])
							.map((use, index) => {
								const commonPests = use.common_pests
									? use.common_pests.split(", ").map((pest) => ({
											value: pest,
											label: pest,
										}))
									: [];

								return (
									<tr key={index} style={rowStyles}>
										<td style={{ ...cellStyles, width: "20%" }}>
											<CreatableSelect
												value={localCrops.find((crop) => crop.value === use.crop_id) || null}
												onChange={(opt, meta) => {
													if (meta.action === "create-option") {
														let newOption = {
															value: meta.option.value,
															label: meta.option.value,
														};
														setLocalCrops([...localCrops, newOption]);
													}

													const updatedCrops = data.uses.map((u) => (u.crop_id === use.crop_id ? { ...u, crop_id: opt.value } : u));
													setData({ ...data, uses: updatedCrops });
												}}
												placeholder="Seleccione"
												options={localCrops}
												components={{ NoOptionsMessage }}
												formatCreateLabel={(value) => `Crear ${value}`}
												isDisabled={true}
												styles={selectStyles}
											/>
										</td>
										<td style={{ ...cellStyles, width: "35%" }}>
											<CreatableSelect
												isMulti
												value={commonPests}
												onChange={(opts, meta) => {
													if (meta.action === "create-option") {
														let newOption = {
															value: meta.option.value,
															label: meta.option.value,
														};
														setLocalPests([...localPests, newOption]);
													}

													const updatedPests = data.uses.map((u) =>
														u.crop_id === use.crop_id && u.type === "comun"
															? { ...u, pests: opts.map((o) => o.value).join(", ") }
															: u,
													);
													setData({ ...data, uses: updatedPests });
												}}
												placeholder="Seleccione"
												options={commonPests}
												components={{ NoOptionsMessage }}
												formatCreateLabel={(value) => `Crear ${value}`}
												isDisabled={true}
												styles={selectStyles}
											/>
										</td>
										<td style={{ ...cellStyles, width: "10%" }}>
											<Form.Control
												value={use.grace_period}
												onChange={(e) => {
													const updatedUses = data.uses.map((u) =>
														u.crop_id === use.crop_id ? { ...u, grace_period: e.target.value } : u,
													);
													setData({ ...data, uses: updatedUses });
												}}
												disabled
												className="text-center"
											/>
										</td>
										<td style={{ ...cellStyles, width: "10%" }}>
											<Form.Control
												value={use.re_entry}
												onChange={(e) => {
													const updatedUses = data.uses.map((u) =>
														u.crop_id === use.crop_id ? { ...u, re_entry: e.target.value } : u,
													);
													setData({ ...data, uses: updatedUses });
												}}
												disabled
												className="text-center"
											/>
										</td>
									</tr>
								);
							})
					) : (
						<tr>
							<td colSpan={4} className="text-center">
								No hay usos registrados
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</Row>
	);
};

export default TabUses;
